/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Save_Offer_TitleInputs */

const en_cancel_save_offer_title = /** @type {(inputs: Cancel_Save_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What if we paused your subscription?`)
};

const de_cancel_save_offer_title = /** @type {(inputs: Cancel_Save_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was, wenn wir dein Abo pausieren?`)
};

const fr_cancel_save_offer_title = /** @type {(inputs: Cancel_Save_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et si nous mettions ton abonnement en pause ?`)
};

const es_cancel_save_offer_title = /** @type {(inputs: Cancel_Save_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Y si pausamos tu suscripcion?`)
};

const it_cancel_save_offer_title = /** @type {(inputs: Cancel_Save_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E se mettessimo in pausa il tuo abbonamento?`)
};

const nl_cancel_save_offer_title = /** @type {(inputs: Cancel_Save_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat als we je abonnement pauzeren?`)
};

const pl_cancel_save_offer_title = /** @type {(inputs: Cancel_Save_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A gdybysmy wstrzymali subskrypcje?`)
};

const fi_cancel_save_offer_title = /** @type {(inputs: Cancel_Save_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entapa jos tauottaisimme tilauksesi?`)
};

const da_cancel_save_offer_title = /** @type {(inputs: Cancel_Save_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad hvis vi satte dit abonnement på pause?`)
};

const sv_cancel_save_offer_title = /** @type {(inputs: Cancel_Save_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vad om vi pausade din prenumeration?`)
};

/**
* | output |
* | --- |
* | "What if we paused your subscription?" |
*
* @param {Cancel_Save_Offer_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_save_offer_title = /** @type {((inputs?: Cancel_Save_Offer_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Save_Offer_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_save_offer_title(inputs)
	if (locale === "fr") return fr_cancel_save_offer_title(inputs)
	if (locale === "es") return es_cancel_save_offer_title(inputs)
	if (locale === "it") return it_cancel_save_offer_title(inputs)
	if (locale === "nl") return nl_cancel_save_offer_title(inputs)
	if (locale === "pl") return pl_cancel_save_offer_title(inputs)
	if (locale === "fi") return fi_cancel_save_offer_title(inputs)
	if (locale === "da") return da_cancel_save_offer_title(inputs)
	if (locale === "sv") return sv_cancel_save_offer_title(inputs)
	return en_cancel_save_offer_title(inputs)
});